const VoucherReconciliationType = {
  NOT_SUBMIT_YET: 0,
  WAIT_FOR_REVIEW: 1,
  APPROVED: 2,
  REJECTED: 3
}
export default VoucherReconciliationType
